import { AxiosResponse } from "axios";
import { AliasViewModel } from "../aliases/AliasStore";
import { MatchParticipantViewModel } from "../matches/MatchesStore";
import axios, { APIWrapperResponse, DefaultResponse, TypedResponse } from "../general/HttpClient";

export function getMaps(organizationID) {
    return axios.get("/api/Maps/getMaps", { params: { organizationID } }).then((response: AxiosResponse<APIWrapperResponse<Array<MapViewModel>>>) => {
        return response.data.result;
    });
}

export function getMap(id) {
    return axios.get(`/api/Maps/getMap/${id}`).then((response: AxiosResponse<APIWrapperResponse<MapViewModel>>) => {
        return response;
    });
}

export function createMap(request: CreateMapRequest) {
    return axios.post(`/api/Maps/createMap`, request).then((response: AxiosResponse<APIWrapperResponse<TypedResponse<MapViewModel>>>) => {
        return response.data.result;
    });
}

export function updateMap(request: UpdateMapRequest | MapViewModel) {
    return axios.put(`/api/Maps/updateMap`, request).then((response: AxiosResponse<APIWrapperResponse<DefaultResponse>>) => {
        return response.data.result;
    });
}

export interface MapViewModel {
    id: string;
    organizationID: string;
    name: string;
    logoUri: string;
    splashUri: string;
    contentUri: string;
    description: string;
    isPublic: boolean;
    downloads: number;
    createdDate: string;
}

export interface CreateMapRequest {
    organizationID: string;
    name: string;
    logoUri: string;
    logoContent: string;
    splashUri: string;
    splashContent: string;
    content: string;
    description: string;
    isPublic: boolean;
    mapFileExt: string;
}

export interface UpdateMapRequest {
    organizationID: string;
    id: string;
    name: string;
    logoUri: string;
    logoContent?: string;
    splashUri: string;
    splashContent?: string;
    description: string;
    content: string;
    isPublic: boolean;
    mapFileExt: string;
}
